import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MomentModule } from "ngx-moment";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
//import { TimepickerModule } from 'ngx-bootstrap/timepicker'
import { PopoverModule } from "ngx-bootstrap/popover";
import { BaseChartDirective } from "ng2-charts";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ColorPickerModule } from "ngx-color-picker";
import { SharedModule } from "../shared/shared.module";
import { AnalyticsRouting } from "./analytics.routing";
import { BrowserModule } from "@angular/platform-browser";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatTooltip } from "@angular/material/tooltip";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatCardModule } from "@angular/material/card";

//import { MatHeaderRowDef, MatRowDef, MatColumnDef } from '@angular/material/table';

import { ChartDetailsPage, CustomDashboardPage } from "./index";
import { TopSearchTermsChartComponent } from "./charts/top-search-terms/chart/top-search-terms-chart.component";
import { GlobalSearchTermChartComponent } from "./charts/global-search-terms/chart/global-search-term-chart.component";
import { GlobalSearchTermDocumentsChartComponent } from "./charts/global-search-terms-documents/chart/global-search-term-documents-chart.component";
import { AnalyticsBaseChartComponent } from "./component/analytics-base-chart/analytics-base-chart.component";
import { DynamicChartComponent } from "./component/dynamic-analytics-chart/dynamic-analytics-chart.component";
import { AccountStatusChartComponent } from "./charts/account-status/chart/account-status-chart.component";
import { AppLanguageChartComponent } from "./charts/app-language/chart/app-language-chart.component";
import { AppVersionChartComponent } from "./charts/app-version/chart/app-version-chart.component";
import { OsTypeCountsChartComponent } from "./charts/os-type-counts/chart/os-type-counts-chart.component";
import { OsVersionCountsChartComponent } from "./charts/os-version-counts/chart/os-version-counts-chart.component";
import { UsersTotalChartComponent } from "./charts/users-total/chart/users-total-chart.component";
import { UsersSessionsChartComponent } from "./charts/users-sessions/chart/users-sessions-chart.component";
import { UsersCurrentChartComponent } from "./charts/users-current/chart/users-current-chart.component";
import { UsersCreatedChartComponent } from "./charts/users-created/chart/users-created-chart.component";
import { UsersCreatedTotalChartComponent } from "./charts/users-created-total/chart/users-created-chart-total.component";
import { UsersRemovedChartComponent } from "./charts/users-removed/chart/users-removed-chart.component";
import { UsersRemovedTotalChartComponent } from "./charts/users-removed-total/chart/users-removed-chart-total.component";
import { UsersLockedChartComponent } from "./charts/users-locked/chart/users-locked-chart.component";
import { UsersLockedTotalChartComponent } from "./charts/users-locked-total/chart/users-locked-chart-total.component";
import { ManualsDownloadedChartComponent } from "./charts/manuals-downloaded/chart/manuals-downloaded-chart.component";
import { ManualsLanguageChartComponent } from "./charts/manuals-language/chart/manuals-language-chart.component";
import { ManualsPrintedChartComponent } from "./charts/manuals-printed/chart/manuals-printed-chart.component";
import { ManualsCreatedChartComponent } from "./charts/manuals-created/chart/manuals-created-chart.component";
import { AnnotationsChartComponent } from "./charts/annotations/chart/annotations-chart.component";
import { ManualsOpenedChartComponent } from "./charts/manuals-opened/chart/manuals-opened-chart.component";
import { ManualsCurrentlyOpenChartComponent } from "./charts/manuals-opened-current/chart/manuals-opened-current-chart.component";
import { PagesViewedChartComponent } from "./charts/pages-viewed/chart/pages-viewed-chart.component";
import { ManualsUpdatedChartComponent } from "./charts/manuals-updated/chart/manuals-updated-chart.component";
import { BaseDetailsComponent } from "./component/base-details/base-details.component";
import { ChartDetailsLayoutComponent } from "./component/chart-details-layout/chart-details-layout.component";
import { AccountStatusDetailsComponent } from "./charts/account-status/details/account-status-details.component";
import { AppLanguageDetailsComponent } from "./charts/app-language/details/app-language-details.component";
import { AppVersionDetailsComponent } from "./charts/app-version/details/app-version-details.component";
import { AnnotationsSentDetailsComponent } from "./charts/annotations/details/annotations-sent-details.component";
import { UsersCreatedDetailsComponent } from "./charts/users-created/details/users-created-details.component";
import { UsersCreatedTotalDetailsComponent } from "./charts/users-created-total/details/users-created-details-total.component";
import { UsersCurrentDetailsComponent } from "./charts/users-current/details/users-current-details.component";
import { UsersLockedDetailsComponent } from "./charts/users-locked/details/users-locked-details.component";
import { UsersLockedTotalDetailsComponent } from "./charts/users-locked-total/details/users-locked-details-total.component";
import { UsersRemovedDetailsComponent } from "./charts/users-removed/details/users-removed-details.component";
import { UsersRemovedTotalDetailsComponent } from "./charts/users-removed-total/details/users-removed-details-total.component";
import { SearchTermDetailsComponent } from "./charts/top-search-terms/details/search-term-details.component";
import { GlobalSearchTermDetailsComponent } from "./charts/global-search-terms/details/global-search-term-details.component";
import { GlobalSearchTermDocumentsDetailsComponent } from "./charts/global-search-terms-documents/details/global-search-term-documents-details.component";
import { UsersTotalDetailsComponent } from "./charts/users-total/details/users-total-details.component";
import { UsersSessionsDetailsComponent } from "./charts/users-sessions/details/users-sessions-details.component";
import { OsTypeDetailsComponent } from "./charts/os-type-counts/details/os-type-details.component";
import { OsVersionsDetailsComponent } from "./charts/os-version-counts/details/os-versions-details.component";
import { PagesViewedDetailsComponent } from "./charts/pages-viewed/details/pages-viewed-details.component";
import { ManualsCreatedDetailsComponent } from "./charts/manuals-created/details/manuals-created-details.component";
import { ManualsUpdatedDetailsComponent } from "./charts/manuals-updated/details/manuals-updated-details.component";
import { ManualsPrintedDetailsComponent } from "./charts/manuals-printed/details/manuals-printed-details.component";
import { ManualsDownloadedDetailsComponent } from "./charts/manuals-downloaded/details/manuals-downloaded-details.component";
import { ManualsDownloadedMostDetailsComponent } from "./charts/manuals-downloaded-most/details/manuals-downloaded-most-details.component";
import { ManualsDownloadedLeastDetailsComponent } from "./charts/manuals-downloaded-least/details/manuals-downloaded-least-details.component";
import { ManualsDownloadedNeverDetailsComponent } from "./charts/manuals-downloaded-never/details/manuals-downloaded-never-details.component";
import { ManualsDownloadedMostChartComponent } from "./charts/manuals-downloaded-most/chart/manuals-downloaded-most-chart.component";
import { ManualsDownloadedLeastChartComponent } from "./charts/manuals-downloaded-least/chart/manuals-downloaded-least-chart.component";
import { ManualsDownloadedNeverChartComponent } from "./charts/manuals-downloaded-never/chart/manuals-downloaded-never-chart.component";
import { AnalyticsDisplayListComponent } from "./component/analytics-display-list/analytics-display-list.component";
import { AnalyticsDisplayListSimpleComponent } from "./component/analytics-display-list-simple/analytics-display-list-simple.component";
import { ManualsOpenedDetailsComponent } from "./charts/manuals-opened/details/manuals-opened-details.component";
import { ManualsOpenedCurrentDetailsComponent } from "./charts/manuals-opened-current/details/manuals-opened-current-details.component";
import { ManualsLanguageDetailsComponent } from "./charts/manuals-language/details/manuals-language-details.component";
import { UsersSessionsActiveChartComponent } from "./charts/users-sessions-active/chart/users-sessions-active-chart.component";
import { UsersSessionsActiveDetailsComponent } from "./charts/users-sessions-active/details/users-sessions-active-details.component";
import { AppUsageDetailsComponent } from "./charts/app-usage/details/app-usage-details.component";
import { CombinedSearchTermsChartComponent } from './charts/combined-search-terms/chart/combined-search-terms-chart.component';
import { CombinedSearchTermsDetailsComponent } from './charts/combined-search-terms/details/combined-search-terms-details.component';
import { MatDialogContent } from "@angular/material/dialog";
import { AppUsageBaseGridComponent } from "./charts/app-usage/app-usage-base-grid/app-usage-base-grid.component";
import { MatIconButton } from "@angular/material/button";
import { LineChartLabelHelperComponent } from "./component/line-chart-label-helper/line-chart-label-helper.component";
import { FormatTimePipe } from "app/shared/pipe/fortmatTime.pipe";
import { AnnotationButtonsComponent } from "./component/annotation-buttons/annotation-buttons.component";
import { TooltipCoordinatorService } from "./services/tooltip-coordinator.service";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    MomentModule,
    PaginationModule.forRoot(),
    FormsModule,
    BaseChartDirective,
    SharedModule,
    BsDatepickerModule.forRoot(),
    AnalyticsRouting,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    ColorPickerModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginator,
    MatDialogContent,
    MatIconButton,
    MatTooltip,
    MatExpansionModule,
    MatCardModule,
    FormatTimePipe,
  ],
  declarations: [
    ChartDetailsPage,
    CustomDashboardPage,
    CombinedSearchTermsDetailsComponent,
    CombinedSearchTermsChartComponent,
    TopSearchTermsChartComponent,
    GlobalSearchTermChartComponent,
    GlobalSearchTermDocumentsChartComponent,
    AnalyticsBaseChartComponent,
    AppUsageBaseGridComponent,
    DynamicChartComponent,
    AccountStatusChartComponent,
    AppLanguageChartComponent,
    AppVersionChartComponent,
    OsTypeCountsChartComponent,
    OsVersionCountsChartComponent,
    UsersTotalChartComponent,
    UsersSessionsChartComponent,
    UsersCurrentChartComponent,
    UsersCreatedChartComponent,
    UsersCreatedTotalChartComponent,
    UsersRemovedChartComponent,
    UsersRemovedTotalChartComponent,
    UsersLockedChartComponent,
    UsersLockedTotalChartComponent,
    ManualsDownloadedChartComponent,
    ManualsLanguageChartComponent,
    ManualsPrintedChartComponent,
    ManualsCreatedChartComponent,
    AnnotationsChartComponent,
    ManualsOpenedChartComponent,
    ManualsCurrentlyOpenChartComponent,
    PagesViewedChartComponent,
    ManualsUpdatedChartComponent,
    BaseDetailsComponent,
    ChartDetailsLayoutComponent,
    AccountStatusDetailsComponent,
    AppLanguageDetailsComponent,
    AppUsageDetailsComponent,
    AppVersionDetailsComponent,
    AnnotationsSentDetailsComponent,
    UsersCreatedDetailsComponent,
    UsersCreatedTotalDetailsComponent,
    UsersCurrentDetailsComponent,
    UsersLockedDetailsComponent,
    UsersLockedTotalDetailsComponent,
    UsersRemovedDetailsComponent,
    UsersRemovedTotalDetailsComponent,
    SearchTermDetailsComponent,
    GlobalSearchTermDetailsComponent,
    GlobalSearchTermDocumentsDetailsComponent,
    UsersTotalDetailsComponent,
    UsersSessionsDetailsComponent,
    OsTypeDetailsComponent,
    OsVersionsDetailsComponent,
    PagesViewedDetailsComponent,
    ManualsCreatedDetailsComponent,
    ManualsUpdatedDetailsComponent,
    ManualsPrintedDetailsComponent,
    ManualsDownloadedDetailsComponent,
    ManualsDownloadedMostDetailsComponent,
    ManualsDownloadedLeastDetailsComponent,
    ManualsDownloadedNeverDetailsComponent,
    ManualsDownloadedMostChartComponent,
    ManualsDownloadedLeastChartComponent,
    ManualsDownloadedNeverChartComponent,
    AnalyticsDisplayListComponent,
    AnalyticsDisplayListSimpleComponent,
    AnnotationButtonsComponent,
    ManualsOpenedDetailsComponent,
    ManualsOpenedCurrentDetailsComponent,
    ManualsLanguageDetailsComponent,
    UsersSessionsActiveChartComponent,
    UsersSessionsActiveDetailsComponent,
    LineChartLabelHelperComponent,
  ],
  providers: [
    TooltipCoordinatorService
  ]
})
export class AnalyticsModule {}
